module.exports = __webpack_public_path__ + "static/media/11@2x.2b3e40af.png";